import React from 'react';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';

import Button from 'legacy/common/components/button/Button';

const DiscountCodeEmptyState = ({ handleAddDiscountCode }) => {
  const { t } = useTranslation('events');
  
  return (
    <div
      data-testId="discount-code-empty-container"
      className="py-4 md:w-[420px] mx-auto"
    >
      <div className="pb-10">
        <div className="flex items-center justify-center px-10">
          <img src="/img/events/discount-codes-empty.png" className="w-32" />
          <p className="text-xl md:text-2xl text-primary-500">
            {t('settings.discountCodes.page.emptyStateTitle')}
          </p>
        </div>
        <p className="md:mt-4 px-2 text-sm md:text-base text-primary-500 font-normal text-center">
          {t('settings.discountCodes.page.emptyStateDescription')}
        </p>
      </div>
      <div>
        <Button onClick={handleAddDiscountCode}>
          <div className="flex items-center justify-center">
            <AiOutlinePlusCircle className="mr-2" /> {t('settings.discountCodes.page.addDiscountCode')}
          </div>
        </Button>
      </div>
    </div>
  );
};

export default DiscountCodeEmptyState;
